var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.isLoaded)?_c('div',[(_vm.page)?_c(_vm.component,{tag:"div"}):_vm._t("default")],2):_c('div',{staticClass:"loader"}),_c('p',[_c('router-link',{attrs:{"to":_vm.link}},[_vm._v("Learn How To")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }